var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircularBackArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.25,
    stroke: "#0055CB",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8333 15.1667H11.9458L14.9733 11.5333C15.2683 11.18 15.22 10.6542 14.8666 10.36C14.5125 10.065 13.9875 10.1133 13.6933 10.4667L9.52665 15.4667C9.49415 15.5058 9.47748 15.5517 9.45331 15.595C9.43331 15.63 9.40915 15.66 9.39415 15.6983C9.35665 15.7942 9.33415 15.895 9.33415 15.9967C9.33415 15.9975 9.33331 15.9992 9.33331 16C9.33331 16.0008 9.33415 16.0025 9.33415 16.0033C9.33415 16.105 9.35665 16.2058 9.39415 16.3017C9.40915 16.34 9.43331 16.37 9.45331 16.405C9.47748 16.4483 9.49415 16.4942 9.52665 16.5333L13.6933 21.5333C13.8583 21.7308 14.095 21.8333 14.3333 21.8333C14.5216 21.8333 14.7108 21.77 14.8666 21.64C15.22 21.3458 15.2683 20.82 14.9733 20.4667L11.9458 16.8333H21.8333C22.2933 16.8333 22.6666 16.46 22.6666 16C22.6666 15.54 22.2933 15.1667 21.8333 15.1667",
    fill: "#0055CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularBackArrow);
export default __webpack_public_path__ + "static/media/circularBackArrow.83b56dbb0f92513f3ff16754e9b990c2.svg";
export { ForwardRef as ReactComponent };